module.exports = __webpack_public_path__ + "img/file-earmark-lock2-fill.533f0127.svg";